import { atom } from "recoil";

export interface POICatsState {
    key: number;
    name: string;
    sub_categories?: {
        key: number;
        name: string;
    }[]
}

export interface selPOICatState {
    category: number[];
    subcategory: number[];
}

export const POICategories = atom({
    key: 'POICategories',
    default: [] as POICatsState[],
});
export const selPOICategories = atom({
    key: 'selPOICategories',
    default: { category: [], subcategory: [] } as selPOICatState,
});

export const selectedCategoryState = atom({
    key: 'selectedCategory',
    default: {} as any,
});

export const selecteddropDownDataState = atom({
    key: 'selectedDropDownData',
    default: {} as any,
});

export const selecteddropDownDataLocationState = atom({
    key: 'selectedDropDownDataLocation',
    default: '' as any,
});

// export const selectedSubCatdropDownDataLocationState = atom({
//     key: 'selectedSubCatDropDownDataLocation',
//     default: '' as any,
// });

export type CIFType = 'PoI' | 'CTV' | 'EH';

export const cifTypeState = atom<CIFType[]>({
    key: 'cifTypeState',
    default: localStorage.getItem('selectedtoggles') ? JSON.parse(localStorage.getItem('selectedtoggles')!) : [] as CIFType[],
});

export const prevCifTypeState = atom<CIFType[]>({
    key: 'prevCifTypeState',
    default: localStorage.getItem('selectedtoggles') ? JSON.parse(localStorage.getItem('selectedtoggles')!) : [] as CIFType[],
});

export const brandList = atom({
    key: 'brandList',
    default: { hasBrands: false, brands: [] } as { hasBrands: boolean; brands: any[] },
});

export const selectedBrands = atom({
    key: 'selectedBrands',
    default: [] as any[],
});

export const metricState = atom({
    key: 'metricState',
    default: {
        EH: null,
        CTV: null,
        PoI: null,
    } as { EH: any; CTV: any; PoI: any },
});

export const filtersState = atom({
    key: 'filtersState',
    default: [] as any[],
});

export const filterDefaultState = atom({
    key: 'filterDefaultState',
    default: [] as any[],
});

export const filterLoadingState = atom({
    key: 'filterLoadingState',
    default: false as boolean,
});

export const hoveredBrandState = atom({
    key: 'hoveredBrandState',
    default: null as any,
});

export const focusedPoiState = atom<{
  type: 'poi' | 'mbp' | null;
  data: any;
  x?: number | null;
  y?: number | null;
}>({
  key: 'focusedPoiState',
  default: {
    type: null,
    data: null,
    x: null,
    y: null,
  },
});